import * as React from 'react'
import { Calendar } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { LOCIZE_NAMESPACE } from 'main/common'
import RequestATourModal from 'main/components/tour/RequestATourModal'
import { NAV_MODALS } from 'main/hooks/useSSOContext'
import { palette } from 'main/ui'
import { i18nKeyPrefix } from '../../../i18n'

import CTAButton from '../common/CTAButton'
import useNavContextModal from '../common/useNavContextModal'

const PRE = `${i18nKeyPrefix}-REQUEST-TOUR`

interface IProps extends RouteComponentProps {
  schoolId: number
  hasTourRequests: boolean
  isLoggedIn: boolean
}

function RequestATour(props: IProps) {
  const { schoolId, location, hasTourRequests, isLoggedIn } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const [isModalOpen, openModal, closeModal] = useNavContextModal(
    NAV_MODALS.REQUEST_TOUR,
    location.pathname,
  )

  return (
    <>
      <CTAButton
        full
        icon={<Calendar color={palette.white} />}
        kind="regular"
        label={isLoggedIn && hasTourRequests ? t(`${PRE}-TITLE-PENDING`) : t(`${PRE}-TITLE`)}
        pendo="school-page-request-a-tour-button"
        onClick={() => openModal()}
      />
      {isModalOpen && <RequestATourModal schoolId={schoolId} onRequestClose={() => closeModal()} />}
    </>
  )
}

export default withRouter(RequestATour)
